"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FestivalFormStartCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class FestivalFormStartCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackFestivalFormStartEvent(this.input);
    }
}
exports.FestivalFormStartCommand = FestivalFormStartCommand;
